import { useMutation, useQueryClient } from '@gogame/query';

import { setIsAllowExternalAPI } from 'scenes/TapjoyBidUpdate/sources/tapjoy-bid-update';
import {
  setUpdateIsAllowExternalAPI as key,
  autoUpdateViaAPI as readKey,
} from '../queryKeyFactory';

export const useUpdateIsAllowExternalAPI = () => {
  const queryClient = useQueryClient();

  const updateMutation = useMutation(key(), setIsAllowExternalAPI, {
    refresh: false,
  });

  const handleAction = async ({ value }) => {
    queryClient.setQueryData(readKey, () => value);
    await updateMutation.mutateAsync({ value });
  };
  return [handleAction, updateMutation];
};
